import React from 'react';
import styles from 'signer-app/signature-modal/common/signature-modal-line.module.css';

export const SignatureModalLine = () => (
  <div className={styles.signatureModalLine} />
);
